export default {
    DoisFatores: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "dois-fatores"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/DoisFatores.js
// module id = KpA2
// module chunks = 32